import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { loadCameras } from '../thunks/loadCameras.thunk';

export const camerasAdapter = createEntityAdapter();

/**
 * The cameras of the project open in the Cameras scene (camera-feeds plan,
 * section 7). Never holds a camera password or a viewing token: saving and
 * viewing go through plain thunks that keep them out of actions. A camera's
 * `stillUrl` is signed for about 10 minutes from `loadedAt` (epoch ms), so
 * the list is loaded again before then (useCameraStillRefresh).
 */
const camerasSlice = createSlice({
  name: 'cameras',
  initialState: {
    cameras: camerasAdapter.getInitialState(),
    projectId: null,
    loading: false,
    loaded: false,
    loadedAt: null,
    error: null,
  },
  reducers: {
    cameraSaved(state, action) {
      camerasAdapter.upsertOne(state.cameras, action.payload);
    },
    cameraRemoved(state, action) {
      camerasAdapter.removeOne(state.cameras, action.payload);
    },
  },
  extraReducers(builder) {
    builder
      .addCase(loadCameras.pending, (state, action) => {
        const { projectId } = action.meta.arg;
        if (state.projectId !== projectId) {
          camerasAdapter.removeAll(state.cameras);
          state.loaded = false;
        }
        state.projectId = projectId;
        state.loading = true;
        state.error = null;
      })
      .addCase(loadCameras.fulfilled, (state, action) => {
        if (state.projectId !== action.meta.arg.projectId) return;
        camerasAdapter.setAll(state.cameras, action.payload);
        state.loading = false;
        state.loaded = true;
        state.loadedAt = Date.now();
      })
      .addCase(loadCameras.rejected, (state, action) => {
        if (state.projectId !== action.meta.arg.projectId) return;
        state.loading = false;
        state.loaded = true;
        state.error = action.payload || { status: null, code: null };
      });
  },
});

export const { cameraSaved, cameraRemoved } = camerasSlice.actions;

export default camerasSlice.reducer;
